import React from 'react'

import { bool, node, number, string } from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const SlideDown = ({ timeout, children, active, maxHeight }) => (
  <>
    <CSSTransitionGroup
      transitionName="slide-down"
      transitionEnterTimeout={timeout}
      transitionLeaveTimeout={timeout}
    >
      {
        active && children
      }
    </CSSTransitionGroup>
    <style jsx global>
      {`
        .slide-down-enter {
          max-height: 0px;
          transition: all ${timeout / 1000}s ease-in-out;
          overflow: hidden;
        }
        .slide-down-enter-active {
          height: auto;
          max-height: ${maxHeight};
        }
        .slide-down-leave {
          height: auto;
          max-height: ${maxHeight};
        }
        .slide-down-leave-active {
          overflow: hidden;
          max-height: 0px;
          transition: all ${timeout / 1000}s ease-in-out;
        }
      `}
    </style>
  </>
)

SlideDown.propTypes = {
  timeout: number,
  active: bool,
  children: node,
  maxHeight: string,
}

export default SlideDown
